import React, { useState } from "react";
import { toast } from "react-toastify";
import useStore from "../../../context/useStore";
import tools from "../../../helpers/tools";
import dataService from "../../../helpers/dataService";

const ForceSynchroFTButton = ({ categorie, entiteId, label, onSuccess }) => {
  const [state] = useStore();
  const [isSaving, setIsSaving] = useState(false);

  if (!tools.canForceFTSync(state.auth?.user)) return null;

  const handleClick = () => {
    const confirmMessages = {
      ORIENTATION: "Forcer la resynchronisation de l'orientation avec France Travail ?",
      RDO: "Forcer la resynchronisation de ce RDO avec France Travail ?",
      CER: "Forcer la resynchronisation de ce CER avec France Travail ?",
      RDV: "Forcer la resynchronisation de ce rendez-vous avec France Travail ?",
    };
    const confirmMessage =
      confirmMessages[categorie] ||
      "Forcer la resynchronisation avec France Travail ?";
    if (!window.confirm(confirmMessage)) return;

    setIsSaving(true);
    dataService.post(
      "france-travail/synchroniser",
      { categorie, entiteId },
      () => {
        toast.success("Synchronisation enfilée, rafraîchissement en cours…");
        if (onSuccess) onSuccess();
      },
      () => {},
      () => setIsSaving(false),
    );
  };

  return (
    <button
      type="button"
      className="btn btn-sm btn-outline-primary"
      onClick={handleClick}
      disabled={isSaving}
    >
      {isSaving ? (
        <>
          <i className="fa fa-spinner fa-spin mr-2" />
          {label}
        </>
      ) : (
        <>
          <i className="fa fa-sync mr-2" />
          {label}
        </>
      )}
    </button>
  );
};

export default ForceSynchroFTButton;
